<h1 class="container-heading">Whitelist IP</h1>

<mat-card>
    <mat-card-content>
        <form [formGroup]="formGroup">
            <div class="flex group">
                <mat-form-field class="full">
                    <mat-label>Type</mat-label>
                    <mat-select formControlName="type" required>
                        <mat-option value="LogiviceV3">Logivice V3</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="full">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" required>
                </mat-form-field>

                <mat-form-field class="full">
                    <mat-label>IP or URL</mat-label>
                    <input matInput formControlName="value" required
                           placeholder="203.0.113.10 or dev.scaas.dev">
                </mat-form-field>

                <div class="full">
                    <mat-checkbox formControlName="is_active">Is active</mat-checkbox>
                </div>
            </div>

            <div class="actions">
                <button mat-raised-button (click)="submitForm()" color="primary"
                        [disabled]="!formGroup.valid">
                    Save
                </button>
                &nbsp;
                <button mat-raised-button (click)="close()">
                    Close
                </button>
            </div>
        </form>
    </mat-card-content>
</mat-card>
